import { render, staticRenderFns } from "./AspectPageSingleAdd.vue?vue&type=template&id=ae874a18&scoped=true&"
import script from "./AspectPageSingleAdd.vue?vue&type=script&lang=js&"
export * from "./AspectPageSingleAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae874a18",
  null
  
)

export default component.exports